// extracted by mini-css-extract-plugin
export var fullWidthButton = "_zn-0";
export var tagInputDisabled = "_zn-1";